import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnitSelectComponent } from './pages/unit-select/unit-select.component';
import { LoginComponent } from './pages/login/login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UserListResolverService } from './resolvers/user-list-resolver.service';
import { AppComponent } from './app.component';
import { WebviewMenuResolverService } from './webview/webview-menu-resolver.service';
import { MediaComponent } from './media/media.component';
const isDev = sessionStorage.getItem('dev') == '1';
const debuggerRoute = isDev ? [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'unit-select',
    component: UnitSelectComponent,
    outlet: 'modal'
  }
] : [];

const routes: Routes = [
  // {
  //   path: 'home', component: MainLayoutComponent,
  //   children: [
  //     {
  //       path: 'records-create',
  //       pathMatch: 'full',
  //       component: RecordCreateComponent,
  //       data: {
  //         header: '活動記録を作成',
  //         description: '複数のお子様の記録を作成できます'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   // component: UnitSelectComponent
  //   component: UserTitleSelectComponent,
  //   resolve: [
  //     UserListResolverService
  //   ]
  // },
  ...debuggerRoute,
  {
    path: 'home',
    component: AppComponent,
    resolve: { menuList: WebviewMenuResolverService, userList: UserListResolverService },
    children: [
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      { path: '**', component: PageNotFoundComponent },
    ]
  },
  // {
  //   path: 'login',
  //   component: LoginComponent,
  // },
  // {
  //   path: 'menu',
  //   component: MenuComponent,
  //   outlet: 'modal',
  // },
  // {
  //   path: 'unit-select',
  //   component: UnitSelectComponent,
  //   outlet: 'modal',
  // },
  // {
  //   path: 'alias-select',
  //   component: AliasSelectComponent,
  //   resolve: { aliasList: AliasSelectResolverService, config: ConfigSettingResolver },
  //   outlet: 'modal',
  // },
  // { path: 'action', component: ActionSelectComponent },
  {
    path: 'media/:key',
    component: MediaComponent
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes, { useHash: false, scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
